{
  "actions": "Akce",
  "hideButtonLabel": "Zobrazit méně",
  "noTags": "Žádný",
  "showAllButtonLabel": "Zobrazit vše ({tagCount, number})"
}
